// @ts-nocheck
export default function getAllowancesProperties(properties: { [key: string]: string }) {
    const {
        allowanceApplied,
        hasAllowanceApplied,
        allowanceAppliedDisplay,
        allowanceAvailable,
        hasAllowanceAvailable,
        allowanceAvailableDisplay,
        allowanceRemaining,
        hasAllowanceRemaining,
        allowanceRemainingDisplay,
    } = properties;

    return {
        allowanceApplied,
        hasAllowanceApplied: hasAllowanceApplied === "true",
        allowanceAppliedDisplay,
        allowanceAvailable,
        hasAllowanceAvailable: hasAllowanceAvailable === "true",
        allowanceAvailableDisplay,
        allowanceRemaining,
        hasAllowanceRemaining: hasAllowanceRemaining === "true",
        allowanceRemainingDisplay,
    };
}
